// Types
import { FilterComponentMap } from './FilterFactory.map';
import { FilterFactoryProps, FilterVariant } from './FilterFactory.types';

/**
 * FilterFactory Component.
 *
 * @component
 * @param {FilterFactoryProps<TableData, ColumnNames>} props - The component props.
 * @param {string} props.columnId - The column ID.
 * @param {ColumnFilterProps<TableData>} props.column - The column filter props.
 * @param {Object} props.filterOptionsMap - The map of column IDs to filter options.
 * @param {FilterVariant} props.variant - Optional. Visibility state of a filter.
 * @param {FilterVariant} props.variant - Optional. Flag to determine if the filters are going to be displayed in smaller views.
 *
 * @returns {ReactElement} - The React element representing the filter component or null.
 */
export const FilterFactory = <TableData, ColumnNames extends string>({
  columnId,
  column,
  filterOptionsMap,
  variant = FilterVariant.VISIBLE,
  smallerViews = false,
}: FilterFactoryProps<TableData, ColumnNames>) => {
  // Select the filter option
  const filterOption = filterOptionsMap[columnId as keyof typeof filterOptionsMap];
  // If the filter option exist inject the properties to the component
  return !!filterOption
    ? // Note: The factory don't know that the props are coming mapped for each object.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      FilterComponentMap[filterOption.filter]({ props: filterOption.props as any, column, variant, smallerViews })
    : null;
};
